import React, { useState, useRef } from "react"
import useStyles from "isomorphic-style-loader/useStyles"
import classes from "./style.module.scss"
import { useDispatch } from "react-redux"
import { getProductSearchImageResult } from "../../../../../../api"
import { Iconfont } from "../../../../../components/icon/iconfont"
import { SET_SEARCH_IMAGE_RESULT } from "../../../../../../store/actions/global"
import { FormattedMessage } from "react-intl"
import { IMAGE_GEEKO_LTD } from "../../../../../../constants"
import withSource from '../../../../../hocs/source-scoll'
import withSourceClick from '../../../../../hocs/source-only-click'


const ShopSimilar = withSourceClick(props =>{
    useStyles(classes);

    const { image , productId, innerRef } = props;
    
    const dispatch = useDispatch();
    const loadingRef = useRef(false);
    const [loading,setLoading] = useState(false);

    const searchByImage = async (evt) =>{
        evt.stopPropagation();
        if(!loadingRef.current){
            loadingRef.current = true;
            setLoading(true);
            let imageUrl;
            if(image.indexOf('/') >= 0){
                imageUrl = `${IMAGE_GEEKO_LTD}${image}`;
            }else{
                imageUrl = `${IMAGE_GEEKO_LTD}/large/${image}`;
            }
            let response = await getProductSearchImageResult({productId:productId,imageUrl:imageUrl});
            if(response?.code === 200 && response?.result){
                await dispatch({
                    type:SET_SEARCH_IMAGE_RESULT,
                    payload:{
                        url:imageUrl,
                        result:response?.result,
                        show:true,
                        searchType:1,
                        sensors: {
                            resourcepage_title: "virtual-search",
                            resource_type: 19,
                            resource_position: 1,
                            resource_content: "shop_similar"
                        }
                    }
                });
            }else{
                response?.result && alert(response.result);
            }
            loadingRef.current = false;
            setLoading(false);
        }
    }

    return <span 
        className={classes.ShopSimilar} 
        onClick={searchByImage}
        ref={innerRef}
        data-title="virtual-search"
        data-position={1}
        data-type={19}
        data-content={'shop_similar'}
    >
        <Iconfont className={classes.Icon}>&#xe706;</Iconfont>
        <span className={classes.Font}><FormattedMessage id="shop_similar" defaultMessage="Shop Similar" /></span>

        {
            loading && <Iconfont className={classes.LoadIcon}>&#xe62d;</Iconfont>
        }
    </span>
})

export default ShopSimilar;